import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import WorkflowStepper from './WorkflowStepper';

export default function PageShell({
  title,
  subtitle,
  backTo = '/admin-subscriptions',
  actions,
  showWorkflow = true,
  children,
}) {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', pb: 4 }}>
      <Box
        sx={{
          px: { xs: 2, md: 3 },
          py: 2.5,
          borderBottom: '1px solid rgba(15,23,42,0.06)',
          background:
            'linear-gradient(180deg, rgba(15,23,42,0.03) 0%, transparent 100%)',
        }}
      >
        <Box sx={{ maxWidth: 1280, mx: 'auto' }}>
          <Button
            component={RouterLink}
            to={backTo}
            startIcon={<FiArrowLeft />}
            size="small"
            sx={{ mb: 1, color: '#64748b' }}
          >
            Admin Subscriptions
          </Button>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: 2,
            }}
          >
            <Box>
              <Typography
                component="h1"
                sx={{
                  fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                  fontWeight: 700,
                  color: '#0f172a',
                  letterSpacing: '-0.02em',
                }}
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography sx={{ color: '#64748b', mt: 0.5 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
            {actions}
          </Box>
        </Box>
      </Box>
      <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, md: 3 }, pt: 3 }}>
        {showWorkflow && <WorkflowStepper />}
        {children}
      </Box>
    </Box>
  );
}
